module.exports = __webpack_public_path__ + "static/media/amex.4122bdf7.svg";